<mat-form-field class="tag-input" appearance="fill">
  <mat-chip-grid #taglist>
    @for (tag of selectedTags; track tag) {
      <mat-chip-row selected color="primary"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(tag)"
        >
        {{tag}}
        @if (removable) {
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
    }
    <input placeholder="Add Tags"
      #tagInput
      [formControl]="tagCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="taglist"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (tag of filteredTags | async; track tag) {
        <mat-option [value]="tag">
          {{tag}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
